import './App.css';
import Home from './views/Home';

function App() {
  return (
    <div className="container">
      <Home />
    </div>
  );
}

export default App;
